import {
    library 
} from '@fortawesome/fontawesome-svg-core';

// import your icons
import { 
    faEye, 
    faEyeSlash,
    faClone
} from '@fortawesome/free-regular-svg-icons';

import {
    faAngleDown,
    faAngleUp,
    faCaretRight,
    faCaretLeft,
    faFilter,
    faEllipsisV,
    faPlus,
    faSortUp,
    faSortDown,
    faSort,
    faCheck,
    faTimes,
    faPen,
    faExclamationTriangle,
    faSync,
    faTrash
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faEye,
    faEyeSlash,
    faAngleDown,
    faAngleUp,
    faCaretRight,
    faCaretLeft,
    faFilter,
    faEllipsisV,
    faPlus,
    faSortUp,
    faSortDown,
    faSort,
    faCheck,
    faTimes,
    faPen,
    faExclamationTriangle,
    faSync,
    faClone,
    faTrash
);

export default library;